import { render } from "./SettingsDatatableFormPayMethodTitle.vue?vue&type=template&id=0af2d791"
import script from "./SettingsDatatableFormPayMethodTitle.vue?vue&type=script&lang=js"
export * from "./SettingsDatatableFormPayMethodTitle.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__